import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-1017",
  "use": "icon-1017-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-1017\" viewBox=\"0 0 16 16\" id=\"icon-1017\">\n  <path d=\"M.694 4.759h14.601a.7.7 0 1 0 0-1.4H.694a.7.7 0 1 0 0 1.4zM15.295 7.16H.694a.7.7 0 1 0 0 1.4h14.601a.7.7 0 1 0 0-1.4zm0 3.801H.694a.7.7 0 1 0 0 1.4h14.601a.7.7 0 1 0 0-1.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol